module.exports = __webpack_public_path__ + "img/slider.8fa9fbf4.svg";